import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  alerta: {
    backgroundColor: "#fff3cd",
    color: "#856404",
    border: "1px solid #ffeeba",
    padding: "16px",
    borderRadius: "8px",
    marginTop: "16px",
    animation: "$pulse 1.5s infinite",
  },
  "@keyframes pulse": {
    "0%": { boxShadow: "0 0 0 0 rgba(255,193,7, 0.4)" },
    "70%": { boxShadow: "0 0 0 10px rgba(255,193,7, 0)" },
    "100%": { boxShadow: "0 0 0 0 rgba(255,193,7, 0)" },
  },
});

interface DisclaimerProps {
  message: string;
}

const DisclaimerAlerta: React.FC<DisclaimerProps> = ({ message }) => {
  const classes = useStyles();

  return (
    <Box className={classes.alerta}>
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

export default DisclaimerAlerta;
